
// THIS FILE IS AUTO-GENERATED FROM SCSS THEME FILES
// DO NOT EDIT MANUALLY - RUN 'yarn run theme:generate' TO REGENERATE
// GENERATED AT: 2026-02-13T15:34:10.384Z

import {
	useMemo,
} from 'react'

import {
	useTheme,
} from '@/shared/lib/hooks'

import type {
	IThemeColors,
} from './theme-colors.types'

/**
 * Hook that provides direct access to current theme colors
 * Auto-generated from SCSS files - DO NOT EDIT MANUALLY!
 *
 * @param mode - 'computed' returns actual RGB values, 'css' returns CSS variables
 * @returns object with current theme colors
 */
export const useThemeColors = (mode: 'computed' | 'css' = 'computed'): IThemeColors => {
	const {
		actualTheme, stylesReady,
	} = useTheme()

	return useMemo(() => {
		const getCSSVar = (varName: string): string => {
			if (typeof window === 'undefined') {
				return ''
			}

			if (mode === 'css') {
				return `var(${varName})`
			}

			if (!stylesReady) {
				return ''
			}

			const value = getComputedStyle(document.documentElement)
				.getPropertyValue(varName)
				.trim()

			return value
		}

		return {
			primaryColor:             getCSSVar('--primary-color'),
			primaryColorOpacity0:     getCSSVar('--primary-color-opacity-0'),
			primaryColorOpacity10:    getCSSVar('--primary-color-opacity-10'),
			primaryColorOpacity20:    getCSSVar('--primary-color-opacity-20'),
			primaryColorOpacity30:    getCSSVar('--primary-color-opacity-30'),
			primaryColorOpacity40:    getCSSVar('--primary-color-opacity-40'),
			primaryColorOpacity50:    getCSSVar('--primary-color-opacity-50'),
			primaryColorOpacity70:    getCSSVar('--primary-color-opacity-70'),
			primaryColorHover:        getCSSVar('--primary-color-hover'),
			onPrimaryColor:           getCSSVar('--on-primary-color'),
			secondaryFillColor:       getCSSVar('--secondary-fill-color'),
			secondaryHintColor:       getCSSVar('--secondary-hint-color'),
			secondaryColor:           getCSSVar('--secondary-color'),
			secondaryColorOpacity40:  getCSSVar('--secondary-color-opacity-40'),
			secondaryColorHover:      getCSSVar('--secondary-color-hover'),
			onSecondaryColor:         getCSSVar('--on-secondary-color'),
			neutralColor:             getCSSVar('--neutral-color'),
			neutralColorHover:        getCSSVar('--neutral-color-hover'),
			surfaceColor:             getCSSVar('--surface-color'),
			surfaceColorDim:          getCSSVar('--surface-color-dim'),
			surfaceContainerColor:    getCSSVar('--surface-container-color'),
			surfaceContainerDimColor: getCSSVar('--surface-container-dim-color'),
			onSurfaceColor:           getCSSVar('--on-surface-color'),
			onSurfaceColorHintLight:  getCSSVar('--on-surface-color-hint-light'),
			onSurfaceColorHint:       getCSSVar('--on-surface-color-hint'),
			lightColor:               getCSSVar('--light-color'),
			lightColorOpacity60:      getCSSVar('--light-color-opacity-60'),
			onLightColor:             getCSSVar('--on-light-color'),
			warningColor:             getCSSVar('--warning-color'),
			warningColorDark:         getCSSVar('--warning-color-dark'),
			warningColorOpacity60:    getCSSVar('--warning-color-opacity-60'),
			warningColorOpacity40:    getCSSVar('--warning-color-opacity-40'),
			warningColorOpacity20:    getCSSVar('--warning-color-opacity-20'),
			warningColorOpacity10:    getCSSVar('--warning-color-opacity-10'),
			warningColorHover:        getCSSVar('--warning-color-hover'),
			onWarningColor:           getCSSVar('--on-warning-color'),
			errorColor:               getCSSVar('--error-color'),
			errorColorOpacity70:      getCSSVar('--error-color-opacity-70'),
			errorColorOpacity60:      getCSSVar('--error-color-opacity-60'),
			errorColorOpacity50:      getCSSVar('--error-color-opacity-50'),
			errorColorOpacity40:      getCSSVar('--error-color-opacity-40'),
			errorColorOpacity20:      getCSSVar('--error-color-opacity-20'),
			errorColorOpacity10:      getCSSVar('--error-color-opacity-10'),
			errorColorHover:          getCSSVar('--error-color-hover'),
			onErrorColor:             getCSSVar('--on-error-color'),
			positiveColor:            getCSSVar('--positive-color'),
			positiveColorOpacity60:   getCSSVar('--positive-color-opacity-60'),
			positiveColorOpacity40:   getCSSVar('--positive-color-opacity-40'),
			positiveColorOpacity20:   getCSSVar('--positive-color-opacity-20'),
			positiveColorOpacity10:   getCSSVar('--positive-color-opacity-10'),
			positiveColorHover:       getCSSVar('--positive-color-hover'),
			onPositiveColor:          getCSSVar('--on-positive-color'),
			outlineColorBase:         getCSSVar('--outline-color-base'),
			outlineBase:              getCSSVar('--outline-base'),
			baseBoxShadow:            getCSSVar('--base-box-shadow'),
			baseBoxShadow2:           getCSSVar('--base-box-shadow-2'),
			cardBackgroundColor:      getCSSVar('--card-background-color'),
			donColor:                 getCSSVar('--don-color'),
			donColorDark:             getCSSVar('--don-color-dark'),
			donColorOpacity10:        getCSSVar('--don-color-opacity-10'),
			donColorOpacity20:        getCSSVar('--don-color-opacity-20'),
			donColorOpacity40:        getCSSVar('--don-color-opacity-40'),
			donColorOpacity50:        getCSSVar('--don-color-opacity-50'),
			donColorOpacity60:        getCSSVar('--don-color-opacity-60'),
			donColorOpacity70:        getCSSVar('--don-color-opacity-70'),
			mafiaColor:               getCSSVar('--mafia-color'),
			mafiaColorOpacity10:      getCSSVar('--mafia-color-opacity-10'),
			mafiaColorOpacity20:      getCSSVar('--mafia-color-opacity-20'),
			mafiaColorOpacity40:      getCSSVar('--mafia-color-opacity-40'),
			mafiaColorOpacity50:      getCSSVar('--mafia-color-opacity-50'),
			mafiaColorOpacity60:      getCSSVar('--mafia-color-opacity-60'),
			mafiaColorOpacity70:      getCSSVar('--mafia-color-opacity-70'),
			sheriffColor:             getCSSVar('--sheriff-color'),
			sheriffColorDark:         getCSSVar('--sheriff-color-dark'),
			sheriffColorOpacity10:    getCSSVar('--sheriff-color-opacity-10'),
			sheriffColorOpacity20:    getCSSVar('--sheriff-color-opacity-20'),
			sheriffColorOpacity40:    getCSSVar('--sheriff-color-opacity-40'),
			sheriffColorOpacity50:    getCSSVar('--sheriff-color-opacity-50'),
			sheriffColorOpacity60:    getCSSVar('--sheriff-color-opacity-60'),
			sheriffColorOpacity70:    getCSSVar('--sheriff-color-opacity-70'),
			citizenColor:             getCSSVar('--citizen-color'),
			citizenColorOpacity10:    getCSSVar('--citizen-color-opacity-10'),
			citizenColorOpacity20:    getCSSVar('--citizen-color-opacity-20'),
			citizenColorOpacity40:    getCSSVar('--citizen-color-opacity-40'),
			citizenColorOpacity50:    getCSSVar('--citizen-color-opacity-50'),
			citizenColorOpacity60:    getCSSVar('--citizen-color-opacity-60'),
			citizenColorOpacity70:    getCSSVar('--citizen-color-opacity-70'),
			dayColor:                 getCSSVar('--day-color'),
			nightColor:               getCSSVar('--night-color'),
			accentColor:              getCSSVar('--accent-color'),
			onAccentColor:            getCSSVar('--on-accent-color'),
		}
	// eslint-disable-next-line
	}, [actualTheme, stylesReady, mode])
}

/**
 * Hook that provides CSS variables for theme colors (no flickering)
 * Use this when you want smooth transitions without computed values
 *
 * @returns object with CSS variable references
 */
export const useThemeColorsCSS = (): IThemeColors => {
	return useThemeColors('css')
}
